import { render, staticRenderFns } from "./EmployeeMethodLimits.vue?vue&type=template&id=10c0f91a&"
import script from "./EmployeeMethodLimits.vue?vue&type=script&lang=ts&"
export * from "./EmployeeMethodLimits.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeMethodLimits.vue?vue&type=style&index=0&id=10c0f91a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports